import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, withStyles } from '@material-ui/core';
import React from 'react';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px',
        fontWeight: 700,
        border: '1px solid #ccc',
        textTransform: 'uppercase',
        backgroundColor: 'grey',
        color: 'white'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        border: 'none',
        fontWeight: 600
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const UsedNominalAccountTable = ({ List = [] }) => {
    return (
        <TableContainer>
            <Table style={{ border: '1px solid #f5f5f5' }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Category </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {List.length == 0 ? (
                        <StyledTableRow>
                            <StyledTableCell>No Record Found</StyledTableCell>
                        </StyledTableRow>
                    ) : (
                        List.map((row, index) => (
                            <StyledTableRow>
                                <StyledTableCell>{row.categoryName}</StyledTableCell>
                            </StyledTableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default UsedNominalAccountTable;
